import React, { Component, useEffect, useState } from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import {
  StyledText,
  DynamicButton,
  MainHolder,
  Children,
  Body,
} from "../../../components/common/basic";

import { logEvent } from "firebase/analytics";
import analytics from "../../../context/analytics";
import RewardItemCard from "../mashupnwin/components/RewardItemCard";
import MashupRedemptionStatus from "../mashupnwin/components/MashupRedemptionStatus";
import {
  AlertModal,
  BackButton,
  FullScreenSelect,
  QuantityControl,
} from "../../../components/common";
import useReferralWinPickup from "./hooks/useReferralWinPickup";
import useReferralRedemptions from "./hooks/useReferralRedemptions";

const ReferralReward = () => {
  const history = useHistory();
  const { referralsRewardItems } = useReferralRedemptions();
  const { id } = history.location.state;
  const item = referralsRewardItems.find((item) => item.code === id);

  useEffect(() => {
    analytics().then((anl) =>
      logEvent(anl, "screen_view", {
        firebase_screen: "MashupAndWinPickup",
        firebase_screen_class: "MashupAndWinPickup",
      })
    );
  }, []);

  useEffect(() => {
    if (!id) {
      history.push("/referral/rewards");
    }
  }, [id, history]);

  const {
    background,
    regionFmt,
    showAlert,
    setShowAlert,
    quantity,
    setQuantity,
    region,
    setRegion,
    officeLocation,
    setOfficeLocation,
    officeLocations,
    isValidQuantity,
    handleSubmit,
    updatedUserPoints,
    setItemCode,
    error,
    loading,
    redeemedId,
  } = useReferralWinPickup();

  useEffect(() => {
    if (item) {
      setItemCode(item.code);
      if (item.category === "data") {
        setRegion("N/A");
        setOfficeLocation("N/A");
        setQuantity(1);
      }
    }
  }, [item, officeLocation]);

  return (
    <>
      <MainHolder>
        <BackButton
          onClick={() => {
            history.goBack();
          }}
        />
        <Children>
          <Header>
            <div style={{ textAlign: "center" }}>
              <StyledText
                size={24}
                style={{ fontFamily: "MTNMedium" }}
                margin="0"
              >
                {"Survey rewards"}
              </StyledText>
            </div>
          </Header>
          <Body>
            {
              showAlert && (
                <AlertModal
                  background={background}
                  success={error === null}
                  onClick={() => {
                    setShowAlert(false);
                  }}
                >
                  {
                    error ?
                      <MashupRedemptionStatus
                        label="Close"
                        message={error?.response?.data?.message || "Redemption Failed"}
                        onActionClick={() => setShowAlert(false)}
                        background={background}
                        history={history}
                      />
                      : <MashupRedemptionStatus
                        label="Track Redemption"
                        onActionClick={() => history.push('/referral/redemptionstatus', { id: redeemedId })}
                        background={background}
                        history={history}
                      />
                  }
                </AlertModal>
              )
            }

            <div style={{ boxSizing: "border-box", padding: "0 15px" }}>
              <RewardItemCard
                image={
                  `${item?.imageUrl}`
                }
                name={item?.name}
                points={item?.points}
                showStatus={false}
                color={"red"}
              />
              <hr
                style={{
                  margin: "15px 0",
                  borderTop: "none",
                  borderBottom: "1px solid #ddd",
                }}
              />

              {
                item?.category !== "data" &&
                <QuantityControl
                  title="Quantity to Redeem"
                  value={quantity}
                  setValue={item?.category === "data" ? () => { } : setQuantity}
                  iconBackground={"red"}
                />
              }

              {
                item?.category !== "data" &&
                <div style={{ marginBottom: "150px" }}>
                  <StyledText size={18} style={{ fontFamily: "MTNRegular" }}>
                    Pickup from MTN Office{" "}
                  </StyledText>
                  <FullScreenSelect
                    placeholder="Region"
                    data={regionFmt}
                    selected={region}
                    setValue={setRegion}
                    activeColor={background}
                  />
                  <FullScreenSelect
                    placeholder="MTN Office"
                    data={officeLocations}
                    selected={officeLocation}
                    setValue={setOfficeLocation}
                    activeColor={background}
                  />
                </div>
              }

              <div
                style={{
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  width: "100%",
                  background: "#fff",
                  borderTop: "1px solid #ddd",
                }}
              >
                <div style={{ padding: "10px" }}>
                  {updatedUserPoints < 0 && (
                    <StyledText
                      color="red"
                      style={{ textAlign: "center", margin: 0 }}
                    >
                      You do not have enough points to redeem
                    </StyledText>
                  )}
                </div>
                <div style={{ padding: "10px 30px" }}>
                  <DynamicButton
                    onClick={() => {
                      if (!loading) handleSubmit()
                    }}
                    label={loading ? "Processing..." : "Redeem"}
                    disabled={
                      !isValidQuantity ||
                      !region || loading ||
                      updatedUserPoints < 0 ||
                      !officeLocation
                    }
                    color={background}
                    fullWidth
                  />
                </div>
              </div>
            </div>
          </Body>
        </Children>
      </MainHolder>
    </>
  );
};

const Header = styled.div`
  /* width: 360px; */
  overflow: hidden;
  padding: 20px 20px 10px 20px;
  background-color: ${({ background }) => background};
  position: relative;
`;

export default ReferralReward;
